import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useProcessCession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      agio,
      cededAt,
      cessionId,
    }: {
      agio: number;
      cededAt: string;
      cessionId: number;
    }) => capitalMarketsService.processCession(cessionId, { agio, ceded_at: cededAt }),
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Erro ao processar cessão';
      toast.error(errorMessage);
    },
    onSuccess: (data) => {
      toast.success(data.message || 'Cessão processada com sucesso');
      queryClient.invalidateQueries({ queryKey: ['cession', 'detail'] });
    },
  });
}
